import { render, staticRenderFns } from "./scopeManagement.vue?vue&type=template&id=0c269cc2&scoped=true"
import script from "./scopeManagement.vue?vue&type=script&lang=js"
export * from "./scopeManagement.vue?vue&type=script&lang=js"
import style0 from "./scopeManagement.vue?vue&type=style&index=0&id=0c269cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c269cc2",
  null
  
)

export default component.exports